import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=a6f8e5fe&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=ts&"
export * from "./Payments.vue?vue&type=script&lang=ts&"
import style0 from "./Payments.vue?vue&type=style&index=0&id=a6f8e5fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f8e5fe",
  null
  
)

export default component.exports